import { render, staticRenderFns } from "./ModulePrimaryIssPageDetails.vue?vue&type=template&id=de54b264&"
import script from "./ModulePrimaryIssPageDetails.vue?vue&type=script&lang=js&"
export * from "./ModulePrimaryIssPageDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports